export default {
  text_one: 'Ansaitse {{count}} piste',
  text_other: 'Ansaitse {{count}} pistettä',
};
